module.exports = __webpack_public_path__ + "img/2.3210a63c.png";